export default {
	name: "indexView",
	data() {
		return {
			detail: {},
			comment: {},
			suggest: [],
			commentVal: ""
		};
	},
	props: ['group', 'articleId'],
	watch: {},
	created() {},
	async mounted() {
		await this.getDetail();
		await this.getComment();
		await this.getSuggest();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getDetail() {
			const detailRes = await this.$zkHttp.index$getStudenArticleDetail({
				article_id: this.articleId
			});
			console.log("detailRes", detailRes);
			this.detail = detailRes;
		},
		async getComment() {
			const commentRes = await this.$zkHttp.index$getCommentList({
				article_id: this.articleId
			});
			console.log("commentRes", commentRes);
			this.comment = commentRes;
		},
		async getSuggest() {
			const suggestRes = await this.$zkHttp.index$getSuggestArticle();
			console.log("suggestRes", suggestRes);
			this.suggest = suggestRes;
		},
		backtoList() {
			this.$router.replace({
				name: 'studentList',
				query: {
					group: this.group
				}
			});
		},
		async gotoStDetail(id) {
			this.articleId = id;
			await this.getDetail();
			// this.$router.replace({name: 'studentDetail', query: {group: this.group, articleId: id}});
		},
		async addLike() {
			const likeRes = await this.$zkHttp.index$addLikes({
				user_id: this.$store.state.auth.user_id,
				article_id: this.detail.id
			});
			console.log("likeRes", likeRes);
			this.$message({
				message: "已点赞",
				type: "success", // message type: success/warning/info/error
			});
			await this.getDetail();
		},
		async addComment() {
			if (!this.commentVal) return;
			const addRes = await this.$zkHttp.index$addComment({
				article_id: this.atc_id,
				user_id: this.$store.state.auth.user_id,
				parent_id: "",
				content: this.commentVal
			});
			console.log("addRes ===> ", addRes);
			if (addRes) {
				this.commentVal = "";
				this.$message({
					message: "评论成功",
					type: "success", // message type: success/warning/info/error
				});
				await this.getComment();
			}

		}
	},
};